'use client';

import { SpotMarketConfig } from '@drift-labs/sdk';
import React from 'react';
import BaseModal from 'src/components/primitives/BaseModal/BaseModal';
import Button from 'src/components/primitives/Button/Button';
import UnstakeFormContent from 'src/components/Staking/UnstakeFormContent';
import useUnstakeForm from 'src/components/Staking/hooks/useUnstakeForm';

interface Props {
	onConfirm: () => void;
	isDriftStaking: boolean | undefined;
	selectedIfStakeMarket: SpotMarketConfig;
}

const UnstakeModalContent = ({
	onConfirm,
	isDriftStaking,
	selectedIfStakeMarket,
}: Props) => {
	const {
		isSubmitDisabled,
		isSubmitting,
		handleSubmit,
		submitButtonContent,
		...unstakeFormProps
	} = useUnstakeForm({
		isDriftStaking,
		defaultSelectedMarket: selectedIfStakeMarket,
		onConfirm,
	});

	return (
		<>
			<BaseModal.Body>
				<UnstakeFormContent
					isDriftStaking={isDriftStaking}
					isSubmitting={isSubmitting}
					{...unstakeFormProps}
				/>
			</BaseModal.Body>
			<BaseModal.Footer>
				<Button
					size="md"
					variant="secondary"
					className="w-full"
					disabled={isSubmitDisabled}
					isLoading={isSubmitting}
					onClick={handleSubmit}
				>
					{submitButtonContent}
				</Button>
			</BaseModal.Footer>
		</>
	);
};

export default React.memo(UnstakeModalContent);
